<template>
  <div class="black-inputs">
    <el-row>
      <el-row class="dateChooser" :gutter="5">
        <el-col :span="8">
          <el-date-picker class="datePicker" ref="picker" v-model="datesCash" type="daterange" range-separator="au"
            start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
        </el-col>
        <el-col :span="4">
          <el-select v-model="typeCash" placeholder="Type">
            <el-option label="Caution" value="caution"></el-option>
            <el-option label="Prépaiement" value="prepaiement"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="serviceCash" placeholder="Service">
            <el-option v-for="t in getAllServicesIdsAndName" :key="t" :label="t" :value="t">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input class="inputEuro" placeholder="Prix / couverts" v-model="priceCash"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input class="inputCouv" placeholder="Couverts minimum" v-model="nbCouv"></el-input>
        </el-col>
      </el-row>
    </el-row>
    <el-row v-loading="loading">
      <el-col :span="7" :offset="9">
        <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
      </el-col>
      <el-col :span="7" :offset="1">
        <el-button type="primary" @click="validModifications()">Valider</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { arrayOfTimestamp } from '../../tools/timeTool';

export default {
  name: 'CashEdit',
  data() {
    return {
      datesCash: {},
      typeCash: '',
      serviceCash: '',
      priceCash: null,
      nbCouv: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      getCashEditEntries: 'cash/getCashEditEntries',
      getAllServicesIdsAndName: 'newServices/getAllServicesIdsAndName',
      isVisibleDialogEditCash: 'displayer/isVisibleDialogEditCash'
    }),
    getEntrysIsValid: function () {
      if (this.datesCash.length > 1 &&
        this.typeCash !== '' &&
        this.serviceCash !== '' &&
        this.priceCash !== null &&
        this.nbCouv !== null &&
        Number(this.priceCash).toString() === this.priceCash.toString()) {
        return true
      }

      return false
    }
  },
  methods: {
    ...mapActions({
      createDaysAndService: 'cash/createDaysAndService',
      deleteDayCashDay: 'cash/deleteDayCashDay',
      deleteDayCashDays: 'cash/deleteDayCashDays'

    }),
    ...mapMutations({
      setDialogEditCash: 'displayer/setDialogEditCash',
      setDialogError: 'displayer/setDialogError'
    }),
    closeDialog: function () {
      this.loading = false
      this.setDialogEditCash(false)
    },
    async validModifications() {
      // set data to store
      // Check entrys
      if (this.getEntrysIsValid) {
        // is valid
        let days = arrayOfTimestamp(this.datesCash[0], this.datesCash[1])
        // check entries to delete
        let oldEntries = this.getCashEditEntries
        let oldDays = arrayOfTimestamp(oldEntries.start, oldEntries.end)
        let oldService = oldEntries.service
        // check service
        if (oldService !== this.serviceCash) {
          // delete oldone entries
          this.deleteCashInfos(oldEntries.start, oldEntries.end, oldEntries.service)
        } else {
          // get dif dates
          let dayToDelete = []
          oldDays.forEach(oldDay => {
            let found = days.find((day) => {
              return day === oldDay
            })
            if (!found) dayToDelete.push(oldDay)
          })
          // delete it
          for (let i = 0; i < dayToDelete.length; i++) {
            await this.deleteDayCashDay({
              tId: dayToDelete[i],
              service: oldEntries.service
            })
          }
        }
        // create entry
        this.createDaysAndService({
          days: days,
          service: this.serviceCash,
          content: {
            type: this.typeCash,
            value: Number(this.priceCash),
            nbCouv: Number(this.nbCouv)
          }
        }).then(() => {
          this.closeDialog()
        }).catch((err) => {
          console.error(err)
        })
      } else {
        this.setDialogError(true)
        this.closeDialog()
      }
    },
    initCashData: function () {
      // Set data to form
      let formValues = this.getCashEditEntries
      this.datesCash = [new Date(this.getCashEditEntries.start), new Date(this.getCashEditEntries.end)]
      this.typeCash = formValues.type
      this.serviceCash = formValues.service
      this.priceCash = formValues.value
      this.nbCouv = (formValues.nbCouv) ? formValues.nbCouv : 1
    },
    deleteCashInfos: function (start, end, service) {
      this.loading = true
      this.deleteDayCashDays({
        tIds: arrayOfTimestamp(start, end),
        service: service
      }).then(() => {
        this.closeDialog()
      })
    }
  },
  created: function () {
    this.initCashData()
  },
  watch: {
    'isVisibleDialogEditCash': function (val, oldVal) {
      if (val === true) {
        this.initCashData()
      }
    }
  }
}
</script>

<style lang="scss">
.dateChooser {
  margin-bottom: 30px;
}
</style>
